var map = {
	"./About": [
		5558,
		558
	],
	"./About.tsx": [
		5558,
		558
	],
	"./Companion": [
		90,
		456,
		90
	],
	"./Companion.tsx": [
		90,
		456,
		90
	],
	"./Contact": [
		8249,
		249
	],
	"./Contact.tsx": [
		8249,
		249
	],
	"./Evidence": [
		6862,
		862
	],
	"./Evidence.tsx": [
		6862,
		862
	],
	"./Home": [
		3212,
		212
	],
	"./Home.tsx": [
		3212,
		212
	],
	"./Individuals": [
		2609,
		609
	],
	"./Individuals.tsx": [
		2609,
		609
	],
	"./NotFound": [
		7672,
		672
	],
	"./NotFound.tsx": [
		7672,
		672
	],
	"./Platform": [
		9680,
		680
	],
	"./Platform.tsx": [
		9680,
		680
	],
	"./Resources": [
		6310,
		310
	],
	"./Resources.tsx": [
		6310,
		310
	],
	"./Solutions": [
		1589,
		589
	],
	"./Solutions.tsx": [
		1589,
		589
	],
	"./UseCases": [
		1229,
		229
	],
	"./UseCases.tsx": [
		1229,
		229
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 483;
module.exports = webpackAsyncContext;